module.exports = __webpack_public_path__ + "static/media/uy.6f9a31a3.svg";